import React from 'react';
import { Grid } from '@mui/material';
import Banner from '../../components/services/Banner';
import { Helmet } from 'react-helmet';
import FireFighting from '../../components/services/firefighting'

const FIREFIGHTING = () => {

    return (
        <Grid container style={{width:'100%', justifyContent:'center'}}>
            <Helmet>
<title>Fire Fighting Contractors in India |  Unique Engineers</title>
<meta name="description" content="Fire fighting contractors in India delivering reliable industrial fire protection systems for factories, hospitals, warehouses, and campuses, executed by experienced industrial fire fighting contractors, Unique Engineers." />
<link rel="canonical" href="https://www.uniqueengineersltd.com/services/industrial-fire-fighting-contractors-in-india/" />
            </Helmet>
             <Banner img={'/assets/images/firefighting-banner.jpg'} title= 'React out and Connect' />
            <FireFighting />
        </Grid>
    )

}

export default FIREFIGHTING;